(function replaceFileDirectiveDefinition() {
    'use strict';

    angular.module('ReplaceFile', [])
        .directive('replaceFile', [
            function () {
                return {
                    replace: true,
                    restrict: 'E',
                    scope: {
                        file: '=',
                        callBack: '&onSave',
                    },  
                    templateUrl: '/app/directives/replace-file/replace-file.html',
                    controller: [
                        '$scope', function ($scope) {
                            $scope.aux = {
                                files: [],
                                filesTemp: null
                            };

                            $scope.result = {
                                sourceFile: null,
                                replaceFile: null
                            };


                            $scope.addFile = function () {
                                $scope.aux.files = [];

                                if ($scope.aux.filesTemp && $scope.aux.filesTemp.size) {
                                    $scope.aux.files.push($scope.aux.filesTemp);
                                }

                                $scope.aux.filesTemp = null;
                            }

                            $scope.removeFile = function (file) {
                                $scope.aux.files = [];
                            }

                            $scope.save = function () {
                                $scope.result.replaceFile = $scope.aux.files[0];
                                $scope.callBack({ selected: $scope.result });
                            }

                            $scope.cancel = function () {
                                $scope.result.replaceFile = null;
                                $scope.callBack({ selected: $scope.result });
                            }
                        }],
                    link: function postLink($scope) {
                        $scope.$watch(function () { return $scope.file; }, function (value) {
                            $scope.result.sourceFile = value;
                            if (value) {
                                $('#replaceFileModal').modal('show');
                            } else {
                                $scope.aux.files = [];
                                $('#replaceFileModal').modal('hide');
                            }
                        });


                    }
                };
            }]);

})();